export { default } from './ExpoSquircle';
